module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "section",
    attrs: {
      "id": "sect2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/OEBPS/toc#sect2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Make-Ahead Breakfast Casserole")])]), _vm._v(" "), _c('p', {
    staticClass: "figure"
  }, [_c('img', {
    staticStyle: {
      "height": "70vh"
    },
    attrs: {
      "alt": "",
      "src": "OEBPS/images/6-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "RecipebYieldb"
  }, [_vm._v("Yield: Serves 10–12 | Prep Time: 20 minutes | Cook Time: 50–55 minutes")]), _vm._v(" "), _c('p', {
    staticClass: "extract_r"
  }, [_vm._v("Turkey is a leaner meat than beef, so if you’re ever looking to make your favorite beef recipe a little lighter, try it with turkey! It’ll fill you up just the same without sacrificing taste.")]), _vm._v(" "), _c('p', {
    staticClass: "ingredients"
  }, [_c('strong', [_vm._v("INGREDIENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 pound turkey breakfast sausage links")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 red bell pepper, cut into 1-inch dice")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 small onion, finely diced")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 (8-ounce) package white button mushrooms, sliced")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 cup spinach")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("4 zucchini, thinly sliced")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ teaspoon kosher salt")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("½ teaspoon freshly ground black pepper")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¼ teaspoon garlic powder")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("¼ teaspoon red pepper flakes")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 teaspoon hot sauce")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1½ cups cottage cheese")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 cup shredded reduced-fat sharp cheddar cheese")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("1 cup shredded reduced-fat Parmesan cheese")]), _vm._v(" "), _c('p', {
    staticClass: "rec"
  }, [_vm._v("6 large eggs, lightly beaten")]), _vm._v(" "), _c('p', {
    staticClass: "directions"
  }, [_c('strong', [_vm._v("DIRECTIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("1. Preheat the oven to 350°F. Lightly coat a 9 × 13-inch baking dish with cooking spray.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("2. In a large skillet, add the sausage and sauté until fully cooked, about 5 minutes. Break up into pieces and continue to cook until browned.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("3. Remove from the pan with a slotted spoon and place on a plate lined with paper towels.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("4. Add the bell pepper and onion to the same skillet and sauté until tender, about 4 minutes.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("5. Add the mushrooms and cook for about 4 minutes. Add the spinach, mix, and turn off the heat.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("6. In a large bowl, combine the zucchini with the salt, black pepper, garlic powder, red pepper flakes, and hot sauce.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("7. Stir in the cottage cheese, cheddar cheese, and Parmesan cheese.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("8. Mix in the cooked sausage. Mix in the cooked vegetables, then the eggs.")]), _vm._v(" "), _c('p', {
    staticClass: "recpr"
  }, [_vm._v("9. Spoon the mixture into the baking dish. Bake for 40 to 45 minutes until set and the cheese has melted. Allow to cool for 5 to 10 minutes before serving.")]), _vm._v(" "), _c('p', {
    staticClass: "notehead"
  }, [_c('strong', [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "NotebText"
  }, [_vm._v("You can make this casserole the day before and refrigerate it to bake later. Remove the casserole from the fridge 30 minutes before baking to warm.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0913eaed","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/sect2.vue
// module id = 90
// module chunks = 0